$(document).ready(() => {
    $("#pages-load-all").on("click", function (event) {
        showAllPages();
    })
    $("#news-load-all").on("click", function (event) {
        showAllNews();
    })
});

function showAllPages() {
    event.preventDefault();
    var $resultsDiv = $('#pages-result');
    $.ajax({
        url: '/umbraco/Surface/SearchPage/ShowAllPages',
        type: 'Get',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        success: function (data) {
            $resultsDiv.replaceWith(data);
        },
    });
}

function showAllNews() {
    event.preventDefault();
    var $resultsDiv = $('#news-result');
    $.ajax({
        url: '/umbraco/Surface/SearchPage/ShowAllNews',
        type: 'Get',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        success: function (data) {
            $resultsDiv.replaceWith(data);
        },
    });
}